var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{staticClass:"form-input",attrs:{"checked":_vm.value,"unchecked-value":false,"value":true,"state":_vm.error ? false : null},on:{"change":_vm.input}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }